import SecurityPage from '@/pages/security/SecurityPage.vue'
import CAForm from '@/pages/security/CAForm.vue'
import CertificateForm from '@/pages/security/CertificateForm.vue'
import ConfigurationForm from '@/pages/security/ConfigurationForm.vue'
import PrivateKeysForm from '@/pages/security/PrivateKeysForm.vue'
import PKCSForm from '@/pages/security/PKCSForm.vue'
import CertificatePage from '@/pages/security/CertificatePage.vue'
import PrivateKeysPage from '@/pages/security/PrivateKeysPage.vue'
import CAPage from '@/pages/security/CAPage.vue'
import SSLPage from '@/pages/security/SSLPage.vue'
import SMIMEPage from '@/pages/security/SMIMEPage.vue'
import SecurityForm from '@/pages/security/SecurityForm.vue'
import SecurityFormPEM from "@/pages/security/SecurityFormPEM.vue";
import KeystoreForm from "@/pages/security/KeystoreForm.vue";
import SecuritySSHPage from "@/pages/security/SecuritySSHPage.vue";
import SecuritySSHForm from "@/pages/security/SecuritySSHForm.vue";
import SSHForm from "@/pages/security/SSHForm.vue";


export default [
  {
    path: '/security/form/:store',
    component: SecurityForm,
    props: true
  },
  {
    path: '/security/form/pem/:store',
    component: SecurityFormPEM,
    props: true
  },
  {
    path: '/security/:role',
    component: SecurityPage,
    props: true
  },
  {
    path: '/security/ssh/:id',
    component: SecuritySSHPage,
    props: true
  },
  {
    path: '/security/ssh/form/:id',
    component: SecuritySSHForm,
    props: true
  },
  {
    path: '/security/ssh/:mode/:id',
    component: SSHForm,
    props: true
  },
  {
    path: '/security/ca/:mode/:id',
    component: CAForm,
    props: true
  },
  {
    path: '/security/keystore/:mode/:id',
    component: KeystoreForm,
    props: true
  },
  {
    path: '/security/ca/:id',
    component: CAPage,
    props: true
  },
  {
    path: '/security/certificate/:mode/:id',
    component: CertificateForm,
    props: true
  },
  {
    path: '/security/certificate/:id',
    component: CertificatePage,
    props: true
  },
  {
    path: '/security/configuration/:mode/:id/:idPod/:type',
    component: ConfigurationForm,
    props: true
  },
  {
    path: '/security/privatekey/:mode/:id',
    component: PrivateKeysForm,
    props: true
  },
  {
    path: '/security/privatekeys/:id',
    component: PrivateKeysPage,
    props: true
  },
  {
    path: '/security/pkcs/:mode/:id',
    component: PKCSForm,
    props: true
  },
  {
    path: '/security/configssl/:id',
    component: SSLPage,
    props: true
  },
  {
    path: '/security/configsmime/:id',
    component: SMIMEPage,
    props: true
  }
]
